import fullstackImage from "../../assets/images/services/fullstack.svg"
import frontendImage from "../../assets/images/services/frontend.svg"
import backendImage from "../../assets/images/services/backend.svg"
import uiuxImage from "../../assets/images/services/uiux.svg"
import customSoftwareImage from "../../assets/images/services/custom-software.svg"
import cloudImage from "../../assets/images/services/cloud-cicd.svg"
import seoImage from "../../assets/images/services/seo.svg"
import devopsImage from "../../assets/images/services/devops.svg"

export const serviceItems = [
  {
    id: "fullstack",
    title: "Développement Fullstack",
    highlight: "Du concept à la production",
    image: fullstackImage,
    imageAlt: "Illustration Fullstack Development",
    description:
      "Conception et livraison de solutions web complètes, de l'interface utilisateur aux APIs et à la base de données, avec une architecture évolutive, testable et sécurisée.",
  },
  {
    id: "frontend",
    title: "Développement Frontend",
    highlight: "Rapidité UI et expérience produit",
    image: frontendImage,
    imageAlt: "Illustration Frontend Development",
    description:
      "Création d'interfaces modernes, rapides et responsives avec une attention forte à l'expérience utilisateur, l'accessibilité et la performance perçue.",
  },
  {
    id: "backend",
    title: "Développement Backend",
    highlight: "APIs fiables et logique métier",
    image: backendImage,
    imageAlt: "Illustration Backend Development",
    description:
      "Mise en place de services robustes et maintenables: APIs, authentification, logique métier, intégration des données et supervision applicative.",
  },
  {
    id: "uiux",
    title: "Intégration Maquette (UI/UX)",
    highlight: "Implémentation fidèle au pixel",
    image: uiuxImage,
    imageAlt: "Illustration Integration Maquette UI UX",
    description:
      "Transformation de maquettes Figma ou Adobe XD en interfaces fidèles et fluides, en respectant les standards visuels, l'ergonomie et les contraintes techniques.",
  },
  {
    id: "custom-software",
    title: "Développement de Logiciels Sur Mesure",
    highlight: "Solutions adaptées à vos besoins",
    image: customSoftwareImage,
    imageAlt: "Illustration Custom Software Development",
    description:
      "Développement de logiciels métier sur mesure pour vos besoins spécifiques, avec une approche orientée valeur, qualité de code et évolutivité.",
  },
  {
    id: "cloud-cicd",
    title: "Déploiement Cloud (CI/CD)",
    highlight: "Pipelines de livraison rapides et fiables",
    image: cloudImage,
    imageAlt: "Illustration Cloud Deployment CI CD",
    description:
      "Automatisation du déploiement avec des pipelines CI/CD fiables pour accélérer les livraisons, réduire les erreurs humaines et garantir des mises en production sereines.",
  },
  {
    id: "seo",
    title: "Gestion SEO (Optimisation pour les moteurs de recherche)",
    highlight: "Visibilité et progression du classement",
    image: seoImage,
    imageAlt: "Illustration SEO Management",
    description:
      "Optimisation technique et structurelle pour améliorer la visibilité sur les moteurs de recherche: performance, indexabilité, balisage et bonnes pratiques web.",
  },
  {
    id: "devops",
    title: "DevOps",
    highlight: "Scalabilité, fiabilité, automatisation",
    image: devopsImage,
    imageAlt: "Illustration DevOps",
    description:
      "Mise en place de bonnes pratiques DevOps pour renforcer la collaboration entre dev et ops: monitoring, fiabilité, sécurité et amélioration continue.",
  },
]
